import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const AddPremiumPackaging_Product_Query = graphqlShopifyStorefront(
  `
  query AddPremiumPackaging_Product(
    $country: CountryCode
    $handle: String!
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    productMasked: product(handle: $handle) {
      ...ProductCard_Product
    }
  }
`,
  // [ProductCard_Product_Fragment],
);

export const BaseCartLine_Product_Fragment = graphqlShopifyStorefront(
  `
  fragment BaseCartLine_Product on Product {
    handle
    id
    featuredImageMasked: featuredImage {
      ...Image
    }
    sellingPlanGroupsConnectionMasked: sellingPlanGroups(first: 1) {
      edges {
        node {
          ...SellingPlanGroup
        }
      }
    }
    title
  }
`,
  // [Image_Fragment, SellingPlanGroup_Fragment],
);

export const BaseCartLine_BaseCartLine_Fragment = graphqlShopifyStorefront(
  `
  fragment BaseCartLine_BaseCartLine on BaseCartLine {
    __typename
    ...BaseCartLine
    cost {
      amountPerQuantity {
        amount
        currencyCode
      }
      subtotalAmount {
        amount
        currencyCode
      }
      totalAmount {
        amount
        currencyCode
      }
    }
    id
    merchandise {
      ... on ProductVariant {
        id
        imageMasked: image {
          ...Image
        }
        productMasked: product {
          ...BaseCartLine_Product
        }
        title
        selectedOptions {
          name
          value
        }
      }
    }
    quantity
  }
`,
  // [Image_Fragment, BaseCartLine_Product_Fragment],
);
